
export const getConfig = () => {
  console.log(process.env)
  console.log(window.location.hostname)
  const appVersion = '1.5.4'
  const fieldappVersion = '1.0.83'
  const workReportingAppVersion = '1.0.83'
  const cacheVersion = fieldappVersion
  const dbVersion = 'workorderDB136'
  const dbVersionWorkReporting = 'workreportingDB101'
  const mapapikey = 'AIzaSyCOi3t9_IPSH_HYfOu4iY2WOWQh6nHjCsM'
  const secretkey = 'pdfviewer983242374327423'

  if (window.location.hostname === 'localhost') {
    console.log('Setting up for Local')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'testfieldsystem.localhost') {
    console.log('Setting up for Local')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'testdispatch.localhost') {
    console.log('Setting up for Local')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'testwo.localhost') {
    console.log('Setting up for Local')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'testdispatch.alvahgroup.com') {
    console.log('Setting up for Dev')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'testfieldsystem.alvahgroup.com') {
    console.log('Setting up for Dev')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'testwo.localhost') {
    console.log('Setting up for Dev')
    return {
      apiUrl: 'https://testapi.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'dispatch.alvahgroup.com') {
    console.log('Setting up for Live')
    return {
      apiUrl: 'https://api.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      PSPDFKitLicenseKey: "c4pDvjed7w_2UbW4ze86vSAQpgHZ_0Ya7cm1jbuQRGX5NwVovjjXTqZ5ERl3qp4sgafxkhXcwlGMiImTeN9PQzFYefs1-0KeRWwbt0oT1hRMUC2L6ENDuw3AvzjzpTvtCJQGkOsO7d3Qpl_eK-ubtFWczsB1iqaM2KvZkcGrPm90Enq0U7RjzgLWJrGM5ieChqbe0xecTX6l58EKIJ0EZg7xNE-vZvrewIqlBpn2-11ysNzZ_K6En7gFR4OWRQ35M7x-dwcSIPDryZBNAItXYJ09F4LyyVprRG4393zsxA24DT2pb91qibRlxxVZipxm1UsOKUOUVL4eT_gUru5rnq2ZEs5Mp_mOM6xwkm0Ic7D5mnufRUCae4trt6JtzuusZFcsvn9lP_W-8o51n6lxnYyclR0Eu2lj1OgBUKaanAZU5B0U-rHYksiGJEBgPa2V9ZmmgG-MSYMlYWZWpAk_9uMKKUPjjLi9tHb9CZbE_K45nWj2w9Rc1xhti1dGvHef81dMse3qFu1vGS6UeDVcNxvZhzWhEOo-dZDpsH2daHI9QVt4Kpi5wmyJRKliiRqwiXeRgba-9NWhN32Rid1IGd93ms5nAzG60jneX7UlWaM=",
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
  else if (window.location.hostname === 'fieldsystem.alvahgroup.com') {
    console.log('Setting up for Live')
    return {
      apiUrl: 'https://api.alvahgroup.com',
      version: appVersion,
      fieldappversion: fieldappVersion,
      workreportingappversion: workReportingAppVersion,
      cacheversion: cacheVersion,
      dbversion: dbVersion,
      dbversionwr: dbVersionWorkReporting,
      PSPDFKitLicenseKey: "nY1QGEC_DrDw4mDOcbIWau7Fy67vUzDxKo82EmJQqN3uYCz8Wy01u6GjJUTjIhpP_Zx77z7CbMp_-ez7z8oC7fqRM_Kz3AKLPowtOVXTmp4gaI0P18roR4lN6dblHIHEzbyG-GdorjwdfCjfSnPYSeuckw0TZw8FDwXjRL8pXhX058omJk4q8hYo1KtwyChSIhNorSWhwyhYrNzgiDrOlxdSz6Q-Z0YbRGQaS_BSuh2ZoH__kTLu7JeYNL4o-44UifO0IgljGAFjsKVkfRDvSB4V297Od8eBlZ2mTubOUcViJURoyW8kgHoJAUCCOAOJkUrb295RmnQz5qD_nbLpzWwv0T89o7516nbSynTe7nPQA17f-h1di4-JSwBmwVrh_b0MRwWYezEo_wzvJs1sf8TX_BcmpLra97j0JBOpRHpp1EOLvtTLJleX7qLPjd41brLQhgp09dsoZGdhX74A6L-U-NMuJEpzO15hnjEPnRHe8iBuoGd7i0umsEaZkKPlzkSYwPJ7-dsqggZ2VGsOPNjhf9-MjSQcCeaSumli8689m8i7phyRgm20qmWOClN5zV7KrTtacsHRYaG8jwaQ9gQBoMZhyUEfgvmSsfUua33-4HUA7CXrCPT6A5DCwePW5nSjI8aHEOknQRoR8aiewV6GF6ZAdXNQOh2g45qYjO0=",
      mapapikey: mapapikey,
      secretkey: secretkey,
    }
  }
}
